import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box } from '@chakra-ui/react';
import { AdminListPageLayout } from '../../../components/admin-list-page-layout/admin-list-page-layout';
import theme from '../../../theme';
import React, { useEffect, useState } from 'react';
import { BreadCrumbsComponent } from '../../../components/breadcrumbs/breadcrumbsComponent';
import { DataGrid } from '../../../components/data-grid/data-grid';
import { HTTPMethodType } from '../../../components/data-grid/data-grid-utils';
import { SubHeader } from '../../organizations/subheader';
import { updatedColDefs } from '../external-application-list';
const endpoint = (appName)=>{
    const params = [
        [
            'externalApplicationName',
            `${appName}`
        ]
    ];
    const endPoint = {
        endPoint: `/externalApplication/users/list/v1`,
        HTTPMethodType: HTTPMethodType.GET,
        params: params
    };
    return endPoint;
};
export const defaultExternalApplicationUser = {
    alias: '',
    userId: undefined,
    username: ''
};
export const ExternalAppUserList = ({ columnDefs, onAddUser, onSelection, setStateToDefault, sortablePageable, selectedAppName = 'External app' })=>{
    const [pageSize, setPageSize] = useState(25);
    const handleAddUserClick = ()=>{
        onAddUser(window.location.pathname);
    };
    const handleSelect = (rowData)=>{
        onSelection(rowData, window.location.pathname);
    };
    useEffect(()=>{
        setStateToDefault && setStateToDefault(defaultExternalApplicationUser);
    // eslint-disable-next-line
    }, []);
    const onPageSizeChange = (pageSize)=>{
        setPageSize(pageSize);
    };
    return /*#__PURE__*/ _jsxs(AdminListPageLayout, {
        children: [
            /*#__PURE__*/ _jsx(Box, {
                flexShrink: 0,
                children: /*#__PURE__*/ _jsx(BreadCrumbsComponent, {})
            }),
            /*#__PURE__*/ _jsxs(Box, {
                flex: "1 1 0",
                minHeight: 0,
                display: "flex",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ _jsx(Box, {
                        flexShrink: 0,
                        children: /*#__PURE__*/ _jsx(SubHeader, {
                            title: selectedAppName,
                            actionName: 'Add User',
                            onActionClick: handleAddUserClick,
                            pageSize: pageSize,
                            onPageSizeChange: onPageSizeChange
                        })
                    }),
                    /*#__PURE__*/ _jsx(Box, {
                        paddingTop: theme.space[16],
                        flex: "1 1 0",
                        minHeight: 0,
                        display: "flex",
                        flexDirection: "column",
                        children: /*#__PURE__*/ _jsx(DataGrid, {
                            serverSideInfiniteScroll: true,
                            columnDefs: updatedColDefs(columnDefs),
                            endpointData: endpoint(selectedAppName),
                            filterableOptions: sortablePageable.filterableOptions,
                            onRowClicked: (item)=>{
                                handleSelect(item.data);
                            },
                            paginationPageSize: pageSize
                        })
                    })
                ]
            })
        ]
    });
};
